import { render, staticRenderFns } from "./FixedSidebar.vue?vue&type=template&id=f5735d8c&scoped=true"
import script from "./FixedSidebar.vue?vue&type=script&lang=js"
export * from "./FixedSidebar.vue?vue&type=script&lang=js"
import style0 from "./FixedSidebar.vue?vue&type=style&index=0&id=f5735d8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5735d8c",
  null
  
)

export default component.exports